import { GetterTree } from 'vuex';
import { VehicleDashboardState } from '@/store/modules/vehicleDashboard/vehicleDashboardState';
import { RootState } from '@/store/rootState';
import { GeoJSON } from 'geojson';
import { isLogScreen } from '@/core/interfaces/logScreen';
import { isLogScreenGroup } from '@/core/interfaces/logScreenGroup';

const getters: GetterTree<VehicleDashboardState, RootState> = {
    realtimeMapLayerData: (state: VehicleDashboardState): Record<string, GeoJSON> => {
        if (!state.definition?.realtime_map_layers) {
            return {};
        }

        return state.definition.realtime_map_layers.reduce((acc: Record<string, GeoJSON>, realtimeMapLayer) => {
            const geojson = state.realtimeMapLayers[realtimeMapLayer.topic];

            if (geojson) {
                acc[realtimeMapLayer.topic] = geojson;
            }

            return acc;
        }, {});
    },

    realtimeFootprintTopic: (state: VehicleDashboardState) => {
        if (!state.definition?.realtime_map_layers) {
            return null;
        }

        return state.definition.realtime_map_layers.find(layer => layer.topic === '/ui/footprint')?.topic || null;
    },

    vehicleType: (state: VehicleDashboardState) => {
        return state.vehicleType;
    },

    logScreens: (state: VehicleDashboardState) => state.logScreens?.sort((a, b) => {
        if (isLogScreen(a) && isLogScreenGroup(b)) {
            return -1;
        }

        if (isLogScreenGroup(a) && isLogScreen(b)) {
            return 1;
        }

        return 0;
    }) || [],

    logs: (state: VehicleDashboardState) => state.logs,
};

export default getters;
